import { Button } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import * as React from "react";

import { ErrorSource, IError, ILoggerService } from "../service/logger/ILoggerService";
import { currentMode } from "../util/Mode";
import ServiceRegistry from "../util/ServiceRegistry";
import { ErrorDisplay } from "./ErrorDisplay";

interface IErrorBoundryState {
	errors: IError[];
	loading: boolean;
	prodMode: boolean;
}

interface IErrorBoundryProps {
	type: ErrorSource;
	location: string;
}

export default class ErrorBoundary extends React.Component<IErrorBoundryProps, IErrorBoundryState> {

	constructor(props) {
		super(props);

		this.state = {
			errors: [],
			loading: false,
			prodMode: currentMode.isProd(),
		};
	}

	@autobind
	public componentDidCatch(message, info) {
		const error: IError = { message, info, errorCode: "DEV" };

		// tell the system there was an error and store the error code
		error.errorCode = ServiceRegistry.get(ILoggerService).reportError(this.props.type, error, this.props.location);

		// only one for now
		this.setState({errors: [error], loading: false});
	}

	@autobind
	private doRetry() {
		this.setState({ loading: true });

		// prevent spamming of retry. also makes it so user thinks something is happening
		setTimeout(() => this.setState({ errors: []}), 400);
	}

	public render() {
		if (this.state.errors.length > 0) {
			const { type, location } = this.props;
			const { errors, loading } = this.state;

			return errors.map((error) => (
				<ErrorDisplay error={error} type={type} location={location}>
					<Button onClick={this.doRetry} loading={loading} disabled={loading}>Retry</Button>
				</ErrorDisplay>
			));
		}

		return this.props.children;
	}
}



// WEBPACK FOOTER //
// ./src/core/components/ErrorBoundry.tsx